
export default {
  name: "POSFeaturesMobile",
  props: {
    features: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    scrollToItem(index) {
      this.activeIndex = index;
      const card = this.$refs["card" + index][0];
      const scrollContainer = this.$refs.scrollContainer;
      scrollContainer.scroll({
        left: card.offsetLeft - 28,
        behavior: "smooth",
      });
    },
    onScroll() {
      const scrollContainer = this.$refs.scrollContainer;
      const scrollLeft = scrollContainer.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.features.forEach((item, index) => {
        const card = this.$refs["card" + index][0];
        const distance = Math.abs(card.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.activeIndex = closestIndex;
    },
  },
};
